import { render, staticRenderFns } from "./TreatmentDetailsFooter.vue?vue&type=template&id=8f8ff6f4&scoped=true"
import script from "./TreatmentDetailsFooter.vue?vue&type=script&lang=js"
export * from "./TreatmentDetailsFooter.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDetailsFooter.vue?vue&type=style&index=0&id=8f8ff6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8ff6f4",
  null
  
)

export default component.exports